export const ABSTRACT_EVENT_TYPES = {
  BUNDLE_TO_ENGINE_UPDATE_COMPARISON: 'BUNDLE_TO_ENGINE_UPDATE_COMPARISON',
  BUNDLE_TO_ENGINE_KEY_VALUE_UPDATE_COMPARISON: 'BUNDLE_TO_ENGINE_KEY_VALUE_UPDATE_COMPARISON',
  COUNT_DOWN_UPDATE_COMPARISON: 'COUNT_DOWN_UPDATE_COMPARISON',
  COUNT_DOWN_UPDATE_TOTAL_SEC_COMPARISON: 'COUNT_DOWN_UPDATE_TOTAL_SEC_COMPARISON',
  ELAPSED_SECONDS_UPDATE_COMPARISON: 'ELAPSED_SECONDS_UPDATE_COMPARISON',
  EVERY_SECOND_UPDATE: 'EVERY_SECOND_UPDATE',
  GPIO_READ_UPDATE_COMPARISON: 'GPIO_READ_UPDATE_COMPARISON',
  GPIO_READ_UPDATE_ANY: 'GPIO_READ_UPDATE_ANY',
  LANGUAGE_UPDATE_COMPARISON: 'LANGUAGE_UPDATE_COMPARISON',
  NONE: 0,
  PAD_INPUT_BUTTON_DOWN_COMPARISON: 'PAD_INPUT_BUTTON_DOWN_COMPARISON',
  PAD_INPUT_CHECKBOX_CHECKED_COMPARISON: 'PAD_INPUT_CHECKBOX_CHECKED_COMPARISON',
  PAD_INPUT_CHECKBOX_UNCHECKED_COMPARISON: 'PAD_INPUT_CHECKBOX_UNCHECKED_COMPARISON',
  PAD_HINT_PUBLISHED: 'PAD_HINT_PUBLISHED',
  STATUS_UPDATE_COMPARISON: 'STATUS_UPDATE_COMPARISON',
  STATUS_UPDATE: 'STATUS_UPDATE',
  TIMER_EXPIRED_UPDATE: 'TIMER_EXPIRED_UPDATE',
  POD_NETWORK_UPDATE_COMPARISON: 'POD_NETWORK_UPDATE_COMPARISON',
  POD_NETWORK_KV_COMPARISON: 'POD_NETWORK_KV_COMPARISON',
  SFX_ENDED_UPDATE: 'SFX_ENDED_UPDATE',
  VARIABLE_UPDATE_COMPARISON: 'VARIABLE_UPDATE_COMPARISON',
  VARIABLE_UPDATE_ANY: 'VARIABLE_UPDATE_ANY',
}